import { Trans, useTranslation } from 'react-i18next';
import { Button, RoundBadge } from '@peacecover/component';
import { useGetBettieBalances } from '../../../domains/bettie/ui/hooks/useGetBettieBalances';

interface HeartPopupProps {
  onOpenNext: () => void;
  onClose: () => void;
  onOpenBettieSheet: () => void;
}

const HeartPopup = ({ onOpenNext, onClose, onOpenBettieSheet }: HeartPopupProps) => {
  const { t } = useTranslation();
  const { data: bettieBalances, isLoading } = useGetBettieBalances();
  const currentHearts = bettieBalances?.bettiePoint?.balance ?? 0;
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 z-[1000] flex items-center justify-center">
      <div className="bg-backgroundElevated-dark rounded-[24px] px-[14px] pt-[32px] pb-[16px] w-[311px] flex flex-col gap-[36px] items-center">
        <div className="flex flex-col gap-[8px] items-center">
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-2">
            {t('ScenePreviewDetail.heartPopup.title')}
          </p>
          <p className="text-[15px] leading-[18px] text-main-dark-4">
            {t('ScenePreviewDetail.heartPopup.description')}
          </p>
        </div>
        <div className="flex flex-col gap-[12px] items-center">
          <img
            src="/assets/icons/graphic-3d/3D.like.png"
            alt="Like"
            className="w-[56px] h-[56px]"
          />
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-2 text-center whitespace-pre-line">
            <Trans
              i18nKey="ScenePreviewDetail.heartPopup.openPreviewDescription"
              values={{ count: 2 }}
              components={{
                span: <span className="bg-gradient-single-red bg-clip-text text-transparent" />
              }}
            />
          </p>
        </div>
        <div className="px-[10px] w-full">
          <div className="bg-[linear-gradient(134deg,rgba(255,255,255,0.60)_5.69%,rgba(255,255,255,0.00)_95.22%)] p-[1px] rounded-full">
            <div className="flex items-center justify-between w-full px-[16px] py-[14px] rounded-full bg-separator-dark-1">
              <div className="flex items-center gap-[4px]">
                <img
                  src="/assets/icons/graphic-3d/3D.like.png"
                  alt="Like"
                  className="w-[16px] h-[16px]"
                />
                <p className="text-[14px] font-medium leading-[17px] text-main-dark-3">
                  {t('ScenePreviewDetail.heartPopup.currentHeart')}
                </p>
                <p className="text-[14px] font-bold leading-[17px] text-main-dark-2">
                  {isLoading
                    ? '-'
                    : t('ScenePreviewDetail.heartPopup.heartCount', { count: currentHearts })}
                </p>
              </div>
              <button type="button" onClick={onOpenBettieSheet} className="flex items-center">
                <RoundBadge size="medium" className="bg-[#444] text-pure-white">
                  {t('ScenePreviewDetail.heartPopup.purchase')}
                </RoundBadge>
              </button>
            </div>
          </div>
        </div>
        <div className="flex flex-col px-[8px] w-full">
          <Button
            size="large"
            className="w-full text-pure-white bg-primary-light font-semibold text-[17px]"
            onClick={onOpenNext}
          >
            {t('ScenePreviewDetail.heartPopup.open')}
          </Button>
          <Button
            size="large"
            className="w-full text-primary-light bg-transparent font-semibold text-[17px]"
            onClick={onClose}
          >
            {t('ScenePreviewDetail.heartPopup.later')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeartPopup;
